/* eslint-disable eqeqeq */
import { AnimatePresence, motion } from "framer-motion";
import React, { useCallback, useEffect, useState } from "react";
import MainBody from "../../components/MainBody/MainBody";
import { CalendarDatePicker } from "../../components/CalendarDatePicker";
import {
  LayoutGrid,
  List,
  MoreVertical,
  RefreshCcw,
  SearchIcon,
} from "lucide-react";
import {
  API,
  defaultLimitPagination,
  deleteCall,
  fileUpload,
  get,
  TableClasses,
  TableWrapClasses,
  TDClasses,
  THClasses,
  TRClasses,
} from "../../config";
import moment from "moment";
import InfiniteScroll from "react-infinite-scroll-component";
import {
  Card,
  CardContent,
  CardHeader,
  // CardTitle,
} from "../../components/ui/card";
import { Checkbox } from "../../components/ui/checkbox";
import { Button } from "../../components/ui/button";
import { Label } from "../../components/ui/label";
import {
  formatContactName,
  formatNumber,
  formatSubcontractorName,
} from "../../lib/Misc";
import BootstrapTable from "react-bootstrap-table-next";
import DropDownButton from "../../components/DropDownButton";
import Confirmation from "../../components/Confirmation";
import { Input } from "../../components/ui/input";
import SearchItem from "./BankReconciliationSearch/SearchItem";
import { useLocation, useNavigate } from "react-router-dom";
import Pagination from "../../components/Pagination";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faMoneyBillTransfer,
  faPaperPlane,
  faSearch,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";
import { ResponsiveDrawerForm } from "../../components/ResponsiveDrawerForm";
import UnauthorisedAccess from "../../UnauthorisedAccess";
import { AnimatedTooltip } from "../../components/AnimatedTooltip";
import { useOrganization } from "../../lib/context/OrganisationContext";
import CustomTooltip from "../../components/CustomTooltip";
import CustomLabelText from "../../components/CustomLabelText";
import SearchSelect from "../../components/SearchSelect";
import FilterDropDownButton from "../../components/FilterDropDownButton";

const ReconcileTransactions = ({
  selectedDateRange,
  setSelectedDateRange,
  trustId,
  isDesktop,
  underReview = false,
  readAccess,
  writeAccess,
}) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { organizationData } = useOrganization();
  const query = new URLSearchParams(location.search);
  const defaultView = query.get("view");
  const [dataForGrid, setDataForGrid] = useState([]);
  const [loading, setLoading] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [dataForList, setDataForList] = useState([]);
  const [loadingForList, setLoadingForList] = useState(false);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(defaultLimitPagination);
  const [total, setTotal] = useState();
  const [from, setFrom] = useState();
  const [to, setTo] = useState();
  const [currentPage, setCurrentPage] = useState(1);

  const [sortField, setSortField] = useState("date");
  const [sortOrder, setSortOrder] = useState("ASC");

  const [hasMore, setHasMore] = useState(true);
  const [selectedIds, setSelectedIds] = useState([]);
  const [validIds, setValidIds] = useState([]);

  const [itemId, setItemId] = useState();
  const [itemData, setItemData] = useState();
  const [showDelete, setShowDelete] = useState(false);
  const [showReconcileAll, setShowReconcileAll] = useState(false);
  const [showSearch, setShowSearch] = useState(false);

  const [searchIds, setSearchIds] = useState([]);
  const [updateResponse, setUpdatedResponse] = useState();

  const [view, setView] = useState(defaultView || "grid");
  const [showRefreshModal, setShowRefreshModal] = useState(false);
  const [refreshSelectedDateRange, setRefreshSelectedDateRange] =
    useState(selectedDateRange);

  const items = [
    <div className="grid gap-2">
      <div className="min-w-0">
        <Label htmlFor="contact_id">
          <CustomLabelText
            labelText="Sorting"
            errorField={""}
            className={"mb-2"}
          />
        </Label>
        <div className="relative">
          <SearchSelect
            frameworks={[
              { label: "Latest First", value: "DESC" },
              { label: "Oldest First", value: "ASC" },
            ]}
            optionType={"Sorting"}
            handleSelect={(e) => {
              if (view === "grid" && e !== sortOrder) {
                setDataForGrid([]);
              }
              setSortField("date");
              setSortOrder(e);
            }}
            initialValue={sortOrder}
            disabled={false}
          />
        </div>
      </div>
    </div>,
  ];

  const handleReset = () => {
    setSortField("date");
    setSortOrder("ASC");
  };

  const toggleRefreshModal = () => {
    if (showRefreshModal) {
      setRefreshSelectedDateRange(selectedDateRange);
    }
    setShowRefreshModal(!showRefreshModal);
  };

  const toggleSearchModal = () => {
    setShowSearch(!showSearch);
  };

  const toggleDeleteModal = (id) => {
    if (id) {
      setItemId(id);
    } else {
      setItemId();
    }
    setShowDelete(!showDelete);
  };

  const toggleReconcileAllModal = (id) => {
    setShowReconcileAll(!showReconcileAll);
  };

  // eslint-disable-next-line no-unused-vars
  const handleSorting = (item) => {
    setSortField(item?.field);
    setSortOrder(item?.value);
  };

  const onSearchItem = (id) => {
    setSearchIds((prev = []) => {
      const merged = new Set([...prev, id]);
      return Array.from(merged);
    });
  };

  const removeSearchId = (id) => {
    let newSearchIds = searchIds?.filter((searchId) => searchId !== id);
    setSearchIds(newSearchIds);
  };

  useEffect(() => {
    setDataForGrid([]);
    setDataForList([]);
  }, [underReview]);

  const fetchReconcileTransaction = useCallback(
    async (currentPage) => {
      if (trustId === null) return;

      const isListView = view === "list" ? true : false;
      try {
        isListView ? setLoadingForList(true) : setLoading(true);

        const baseURL = API.BANK_RECONCILIATION_LIST;
        const params = new URLSearchParams({
          trust_id: trustId,
          sort_column: sortField ? sortField : "",
          start_date: moment(selectedDateRange?.from).format("DD-MM-YYYY")
            ? moment(selectedDateRange?.from).format("DD-MM-YYYY")
            : "",
          end_date: moment(selectedDateRange?.to).format("DD-MM-YYYY")
            ? moment(selectedDateRange?.to).format("DD-MM-YYYY")
            : "",
          sort_order: sortOrder ? sortOrder : "",
          limit: isListView
            ? limit?.toString() || defaultLimitPagination.toString()
            : 15,
          page: isListView
            ? page?.toString() || "1"
            : currentPage
            ? currentPage?.toString()
            : "1",
        });

        if (underReview) {
          params.append("under_review", "1");
        }

        const URL = `${baseURL}?${params.toString()}`;
        const response = await get(URL);
        const responseData = response.data.data;

        isListView ? setLoadingForList(false) : setLoading(false);

        if (isListView && responseData) {
          setLimit(responseData?.per_page);
          setPage(responseData?.current_page);
          setCurrentPage(responseData?.current_page + 1);
          setTotal(responseData?.total);
          setFrom(responseData?.from);
          setTo(responseData?.to);
          setDataForList(responseData);
        }
        if (!isListView && responseData) {
          setCurrentPage(responseData?.current_page + 1);

          // Append to existing data if already loaded
          setDataForGrid((prev = []) => {
            const existingIds = new Set(prev.map((item) => item.id));
            const newItems = responseData?.data.filter(
              (item) => !existingIds.has(item.id)
            );
            return [...prev, ...newItems];
          });
        }

        const matchedRecords = [];
        responseData.data?.forEach((element) => {
          element.bank_reconciliation.forEach((item, index) => {
            const isValid =
              (item?.receipt_id ||
                item?.payment_detail_id ||
                item?.invoice_id) &&
              item?.description &&
              item?.amount;

            if (isValid) {
              matchedRecords.push(element.id);
            }
          });
        });

        const uniqueMatched = [...new Set(matchedRecords)];
        let latestPage = isListView
          ? page?.toString() || "1"
          : currentPage
          ? currentPage?.toString()
          : "1";
        setSelectedIds((prev = []) => {
          const merged = new Set(
            latestPage == 1 ? [...uniqueMatched] : [...prev, ...uniqueMatched]
          );
          return Array.from(merged);
        });
        setValidIds((prev = []) => {
          const merged = new Set(
            latestPage == 1 ? [...uniqueMatched] : [...prev, ...uniqueMatched]
          );
          return Array.from(merged);
        });

        if (!isListView) {
          const isMoreDataExist =
            responseData.data.length < responseData.total &&
            responseData?.next_page_url;
          setHasMore(!!isMoreDataExist);
        }
      } catch (e) {
        isListView ? setLoadingForList(false) : setLoading(false);
        isListView ? setDataForList([]) : setDataForGrid([]);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      trustId,
      sortField,
      selectedDateRange?.from,
      selectedDateRange?.to,
      sortOrder,
      underReview,
      view,
    ]
  );

  useEffect(() => {
    fetchReconcileTransaction();
  }, [fetchReconcileTransaction]);

  const handleReconcile = async (ItemID) => {
    if (ItemID !== null) {
      try {
        setLoading(true);
        const formData = new FormData();

        formData.append("trust_id", trustId);
        formData.append("status", "1");
        formData.append("_method", "put");
        const response = await fileUpload(
          `${API.UPDATE_BANK_RECONCILIATION}/${ItemID}`,
          formData
        );
        if (response.status === 200) {
          // view === "grid" ? setDataForGrid([]) : setDataForList([]);
          // fetchReconcileTransaction(currentPage - 1);
          if (ItemID === response?.data?.data?.id) {
            let data = dataForGrid.filter(
              (item) => item.id !== response?.data?.data?.id
            );
            let selectedId = selectedIds.filter(
              (item) => item !== response?.data?.data?.id
            );
            setSelectedIds(selectedId);
            if (view === "grid") {
              setDataForGrid(data);
            } else {
              setDataForGrid(data);
              await fetchReconcileTransaction(currentPage - 1);
            }
          }
        }
        setLoading(false);
      } catch (error) {
        setLoading(false);
      }
    }
  };

  // Toggle single checkbox
  const handleSelectItem = (id) => {
    setSelectedIds((prev) =>
      prev.includes(id) ? prev.filter((itemId) => itemId !== id) : [...prev, id]
    );
  };

  // Select all current visible items
  const handleSelectAll = (e) => {
    if (e?.target?.dataset?.state === "checked") {
      e.target.dataset.state = "";
      setSelectedIds([]);
    } else {
      const matchedRecords = [];
      dataForGrid?.forEach((element) => {
        element.bank_reconciliation.forEach((item) => {
          const isValid =
            // item?.chart_of_account_id &&
            // item?.contact_id &&
            (item?.receipt_id || item?.payment_detail_id || item?.invoice_id) &&
            // (item?.gst || item?.gst === 0) &&
            item?.amount &&
            item?.description
              ? true
              : false;

          // if (underReview || isValid) {
          if (isValid) {
            matchedRecords.push(element.id);
          }
        });
      });

      const uniqueMatched = [...new Set(matchedRecords)];

      setSelectedIds((prev = []) => {
        const merged = new Set([...prev, ...uniqueMatched]);
        return Array.from(merged);
      });
    }
  };

  const columns = [
    {
      headerClasses: `${THClasses} !h-[25px] bg-webSecondary !rounded-none`,
      classes: `${TDClasses} whitespace-normal text-wrap w-1/4 bg-muted dark:border-background align-middle`,
      dataField: "contact",
      text: "Contact",
    },
    {
      headerClasses: `${THClasses} !h-[25px] bg-webSecondary !rounded-none`,
      classes: `${TDClasses} whitespace-normal text-wrap w-1/4 bg-muted dark:border-background align-middle`,
      dataField: "amount",
      text: "Amount",
    },
    {
      headerClasses: `${THClasses} !h-[25px] bg-webSecondary !rounded-none`,
      classes: `${TDClasses} whitespace-normal text-wrap w-3/4 bg-muted dark:border-background align-middle`,
      dataField: "description",
      text: "Description",
    },
  ];

  const updateDescription = async (ItemID, description) => {
    try {
      setLoading(true);
      const formData = new FormData();
      formData.append("trust_id", trustId);
      formData.append("description", description);
      formData.append("_method", "put");
      const response = await fileUpload(
        `${API.UPDATE_BANK_RECONCILIATION}/${ItemID}`,
        formData
      );
      if (response.status === 200) {
        // if (ItemID === response?.data?.data?.id) {
        const updatedRecord = response?.data?.data;
        let data = dataForGrid;
        const index = data?.findIndex(
          (item) => item.id === response?.data?.data?.id
        );
        if (index !== -1) {
          data.splice(index, 1, updatedRecord);
        }

        if (view === "grid") {
          setDataForGrid(data);
          setDataForList([]);
        } else {
          setDataForGrid(data);
          setDataForList([]);
          await fetchReconcileTransaction(currentPage - 1);
        }
        // }

        // (await view) === "grid" ? setDataForGrid([]) : setDataForList([]);
        // await fetchReconcileTransaction(currentPage - 1);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };
  // const updateReviewComment = async (ItemID, comment) => {
  //   try {
  //     setLoading(true);
  //     const formData = new FormData();
  //     formData.append("trust_id", trustId);
  //     formData.append("comment", comment);
  //     formData.append("_method", "put");
  //     const response = await fileUpload(
  //       `${API.UPDATE_BANK_RECONCILIATION}/${ItemID}`,
  //       formData
  //     );
  //     if (response.status === 200) {
  //       if (ItemID === response?.data?.data?.id) {
  //         const updatedRecord = response?.data?.data;
  //         let data = dataForGrid;
  //         const index = data?.findIndex(
  //           (item) => item.id === response?.data?.data?.id
  //         );
  //         if (index !== -1) {
  //           data.splice(index, 1, updatedRecord);
  //         }

  //         if (view === "grid") {
  //           setDataForGrid(data);
  //         } else {
  //           setDataForGrid(data);
  //           await fetchReconcileTransaction(currentPage - 1);
  //         }
  //       }

  //       // (await view) === "grid" ? setDataForGrid([]) : setDataForList([]);
  //       // await fetchReconcileTransaction(currentPage - 1);
  //     }
  //     setLoading(false);
  //   } catch (error) {
  //     setLoading(false);
  //   }
  // };

  const reconiliationDataGenerator = (quantity, reconiliationData) => {
    const items = [];
    for (let i = 0; i < quantity; i++) {
      items.push({
        key: reconiliationData[i]?.id,
        payeer: reconiliationData[i]?.payeer
          ? formatSubcontractorName(reconiliationData[i]?.payeer)
          : "-",
        contact: formatContactName(
          reconiliationData[i]?.contactable_type,
          reconiliationData[i]?.contactable,
          organizationData?.organizationData
        ),
        vendor: reconiliationData[i]?.vendor
          ? formatSubcontractorName(reconiliationData[i]?.vendor)
          : "-",
        asset: reconiliationData[i]?.asset
          ? reconiliationData[i]?.asset?.name
          : "-",
        sub_asset: reconiliationData[i]?.sub_asset
          ? reconiliationData[i]?.sub_asset?.name
          : "-",
        amount: reconiliationData[i]?.amount
          ? `$${formatNumber(Number(reconiliationData[i]?.amount))}`
          : "$0.00",
        description: (
          <Input
            defaultValue={reconiliationData[i]?.description ?? "-"}
            onBlur={(e) => {
              const newValue = e.target.value;
              const id = reconiliationData[i]?.id;

              if (id && newValue !== reconiliationData[i]?.description) {
                updateDescription(id, newValue);
              }
            }}
            className="h-8 px-2 bg-background"
            title={reconiliationData[i]?.description}
          />
        ),
      });
    }
    return items;
  };

  const sendReview = async (ItemID, Item, forList = false) => {
    try {
      setLoading(true);
      const formData = new FormData();
      formData.append("trust_id", trustId);
      formData.append("status", "2");
      formData.append("_method", "put");
      const response = await fileUpload(
        `${API.UPDATE_BANK_RECONCILIATION}/${ItemID}`,
        formData
      );
      if (response.status === 200) {
        // const updatedRecord = response?.data?.data;
        // const index = dataForGrid?.findIndex((item) => item.id === response?.data?.data?.id);
        // if (index !== -1) {
        //   dataForGrid.splice(index, 1, updatedRecord);
        // }

        if (ItemID === response?.data?.data?.id) {
          let data = dataForGrid.filter(
            (item) => item.id !== response?.data?.data?.id
          );
          if (view === "grid") {
            setDataForGrid(data);
          } else {
            setDataForGrid(data);
            await fetchReconcileTransaction(currentPage - 1);
          }
        }

        // (await view) === "grid" ? setDataForGrid([]) : setDataForList([]);
        // await fetchReconcileTransaction(currentPage - 1);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  const bulkReconcile = async () => {
    try {
      setLoading(true);
      const formData = new FormData();
      formData.append("trust_id", trustId);
      for (let i = 0; i < selectedIds?.length; i++) {
        formData.append(`bank_transaction_ids[${i}]`, selectedIds[i]);
      }
      const response = await fileUpload(
        `${API.BANK_RECONCILIATION_BULK}`,
        formData
      );
      if (response.status === 200) {
        let data = dataForGrid.filter(
          (item) => !selectedIds?.includes(item.id)
        );
        if (view === "grid") {
          setDataForGrid(data);
        } else {
          setDataForGrid(data);
          await fetchReconcileTransaction(currentPage - 1);
        }
        toggleReconcileAllModal();
        setSelectedIds([]);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  const bankReconciliationData = (reconiliationData) => {
    return reconiliationDataGenerator(
      reconiliationData?.length,
      reconiliationData
    );
  };

  const handleReconcileDisable = (item) => {
    const value = item?.bank_reconciliation?.map((data, i) => {
      const main =
        // data?.chart_of_account_id &&
        // (data?.gst === "0" || data?.gst) &&
        (data?.receipt_id || data?.payment_detail_id || data?.invoice_id) &&
        data?.description &&
        data?.amount
          ? true
          : false;
      return main;
    });
    const finalValue =
      value?.find((val) => val === false) === false ? true : false;
    return finalValue;
  };

  const handleReconcileTransactionDelete = useCallback(
    async (dataForGrid, ItemID) => {
      try {
        setDeleteLoading(true);
        await deleteCall(`${API.TRANSACTION_DELETE}/${ItemID}`).then(
          (response) => {
            if (response?.status === 200) {
              let data = dataForGrid.filter((item) => item.id !== ItemID);
              let selectedId =
                selectedIds?.length > 0
                  ? selectedIds.filter((item) => item !== ItemID)
                  : [];
              setSelectedIds(selectedId);
              if (view === "grid") {
                setDataForGrid(data);
              } else {
                fetchReconcileTransaction(currentPage - 1);
              }

              // view === "grid" ? setDataForGrid([]) : setDataForList([]);

              // fetchReconcileTransaction(currentPage - 1);

              setShowDelete(false);
            }
            setDeleteLoading(false);
          }
        );
        setDeleteLoading(false);
      } catch (e) {
        setDeleteLoading(false);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  const listColumns = underReview
    ? [
        {
          headerClasses: THClasses,
          classes: `${TDClasses} whitespace-normal text-wrap align-middle`,
          dataField: "check",
          text: "",
          headerStyle: {
            width: "35px",
          },
        },
        {
          headerClasses: THClasses,
          classes: `${TDClasses} whitespace-normal text-wrap align-middle`,
          dataField: "date",
          text: "Date",
        },
        {
          dataField: "description",
          text: "Description",
          headerClasses: THClasses,
          classes: `${TDClasses} whitespace-normal text-wrap align-middle`,
        },

        {
          dataField: "total_amount",
          text: "Debit/Credit",
          headerClasses: THClasses,
          classes: `${TDClasses} whitespace-normal text-wrap align-middle`,
        },

        // {
        //   dataField: "review_notes",
        //   text: "Review Notes",
        //   headerClasses: THClasses,
        //   classes: `${TDClasses} whitespace-normal text-wrap align-middle`,
        // },

        {
          dataField: "contact_name",
          text: "Beneficiary/Contact",
          headerClasses: THClasses,
          classes: `${TDClasses} whitespace-normal text-wrap align-middle`,
        },

        {
          dataField: "amount",
          text: "Amount",
          headerClasses: THClasses,
          classes: `${TDClasses} whitespace-normal text-wrap align-middle`,
        },
        {
          dataField: "description",
          text: "Description",
          headerClasses: THClasses,
          classes: `${TDClasses} whitespace-normal text-wrap align-middle`,
        },

        {
          dataField: "action",
          text: "Action",
          headerClasses: THClasses,
          classes: `${TDClasses} whitespace-normal text-wrap align-middle`,
          align: "center",
          headerAlign: "center",
        },
      ]
    : [
        {
          headerClasses: THClasses,
          classes: `${TDClasses} whitespace-normal text-wrap align-middle`,
          dataField: "check",
          text: "",
          headerStyle: {
            width: "35px",
          },
        },
        {
          headerClasses: THClasses,
          classes: `${TDClasses} whitespace-normal text-wrap align-middle`,
          dataField: "date",
          text: "Date",
        },
        {
          headerClasses: THClasses,
          classes: `${TDClasses} whitespace-normal text-wrap align-middle`,
          dataField: "description",
          text: "Description",
        },
        {
          dataField: "total_amount",
          text: "Debit/Credit",
          headerClasses: THClasses,
          classes: `${TDClasses} whitespace-normal text-wrap align-middle`,
        },
        {
          headerClasses: THClasses,
          classes: `${TDClasses} whitespace-normal text-wrap align-middle`,
          dataField: "contact_name",
          text: "Beneficiary/Contact",
        },
        {
          headerClasses: THClasses,
          classes: `${TDClasses} whitespace-normal text-wrap align-middle`,
          dataField: "amount",
          text: "Amount",
        },
        {
          headerClasses: THClasses,
          classes: `${TDClasses} whitespace-normal text-wrap align-middle`,
          dataField: "comment",
          text: "Description",
        },

        {
          headerClasses: THClasses,
          classes: `${TDClasses} whitespace-normal text-wrap align-middle`,
          dataField: "action",
          text: "Action",
          align: "center",
          headerAlign: "center",
        },
      ];

  const handleUpdateLimit = (e) => {
    const limit = e.target.value;
    setLimit(limit);
    setPage(1);
  };

  const handleChangePage = (page) => {
    setPage(page);
  };

  const listViewDataGenerator = (quantity) => {
    const items = [];
    for (let i = 0; i < quantity; i++) {
      for (
        let j = 0;
        j < dataForList?.data[i]?.bank_reconciliation?.length;
        j++
      ) {
        items.push({
          key: dataForList?.data[i]?.id,

          check:
            j === 0 ? (
              <Checkbox
                checked={selectedIds.includes(dataForList?.data[i].id)}
                onClick={() => handleSelectItem(dataForList?.data[i].id)}
                disabled={
                  // underReview === true
                  //   ? false
                  handleReconcileDisable(dataForList?.data[i])
                }
              />
            ) : (
              <div className="blank-td" />
            ),

          date:
            j === 0 && dataForList?.data[i]?.transaction_date ? (
              moment(
                dataForList?.data[i]?.transaction_date,
                "DD-MM-YYYY"
              ).format("DD-MM-YYYY")
            ) : (
              <div className="blank-td" />
            ),
          description:
            j === 0 && dataForList?.data[i]?.description ? (
              dataForList?.data[i]?.description
            ) : (
              <div className="blank-td" />
            ),
          total_amount:
            j === 0 ? (
              <span
                className={
                  dataForList?.data[i]?.base_type
                    ? "text-green-500"
                    : "text-red-500"
                }
              >
                {dataForList?.data[i]?.amount
                  ? `$${formatNumber(Number(dataForList?.data[i]?.amount))}`
                  : "$0.00"}
              </span>
            ) : (
              <div className="blank-td" />
            ),
          amount: dataForList?.data[i]?.bank_reconciliation[j]?.amount
            ? `$${formatNumber(
                Number(dataForList?.data[i]?.bank_reconciliation[j]?.amount)
              )}`
            : "$0.00",
          // review_notes: underReview ? (
          //   j === 0 ? (
          //     <Input
          //       defaultValue={
          //         dataForList?.data[i].comment
          //           ? dataForList?.data[i].comment
          //           : ""
          //       }
          //       placeholder="Add Comment"
          //       onBlur={(e) => {
          //         const newValue = e.target.value;
          //         const id = dataForList?.data[i]?.id;

          //         if (id && newValue !== dataForList?.data[i].comment) {
          //           updateReviewComment(id, newValue);
          //         }
          //       }}
          //       className="h-8 px-2"
          //       title={dataForList?.data[i].comment}
          //     />
          //   ) : (
          //     <div className="blank-td" />
          //   )
          // ) : (
          //   ""
          // ),
          contact_name: formatContactName(
            dataForList?.data[i]?.bank_reconciliation[j]?.contactable_type,
            dataForList?.data[i]?.bank_reconciliation[j]?.contactable,
            organizationData?.organizationData
          ),
          comment: (
            <Input
              defaultValue={
                dataForList?.data[i]?.bank_reconciliation[j]?.description
                  ? dataForList?.data[i]?.bank_reconciliation[j]?.description
                  : dataForList?.data[i]?.description
              }
              onBlur={(e) => {
                const newValue = e.target.value;
                const id = dataForList?.data[i]?.bank_reconciliation[j]?.id;

                if (
                  id &&
                  newValue !==
                    dataForList?.data[i]?.bank_reconciliation[j]?.description
                ) {
                  updateDescription(id, newValue);
                }
              }}
              className="h-8 px-2"
              title={dataForList?.data[i]?.bank_reconciliation[j]?.description}
            />
          ),
          action:
            j === 0 && writeAccess ? (
              <>
                <div className="flex items-center gap-1 justify-center">
                  {handleReconcileDisable(dataForList?.data[i]) ? (
                    <>
                      <CustomTooltip message={"Reconcile"}>
                        <FontAwesomeIcon
                          className="disabled-font-awesome text-gray-400 cursor-not-allowed"
                          icon={faMoneyBillTransfer}
                          size="1x"
                        />
                      </CustomTooltip>
                    </>
                  ) : (
                    <CustomTooltip message={"Reconcile"}>
                      <FontAwesomeIcon
                        onClick={() => {
                          handleReconcile(dataForList?.data[i].id);
                        }}
                        icon={faMoneyBillTransfer}
                        size="1x"
                      />
                    </CustomTooltip>
                  )}
                  <span className="icon-divider">
                    <b>/</b>
                  </span>
                  <CustomTooltip message={"Search"}>
                    <FontAwesomeIcon
                      onClick={() => {
                        toggleSearchModal();
                        onSearchItem(dataForList?.data[i]?.id);
                        setItemData(dataForList?.data[i]);
                      }}
                      icon={faSearch}
                    />
                  </CustomTooltip>

                  <span className="icon-divider">
                    <b>/</b>
                  </span>

                  {!underReview && (
                    <CustomTooltip message={"Send For Review"}>
                      <FontAwesomeIcon
                        icon={faPaperPlane}
                        size="1x"
                        onClick={() => {
                          sendReview(
                            dataForList?.data[i]?.id,
                            dataForList?.data[i]
                          );
                        }}
                      />
                    </CustomTooltip>
                  )}

                  {!underReview && (
                    <span className="icon-divider">
                      <b>/</b>
                    </span>
                  )}
                  <CustomTooltip message={"Delete Transaction"}>
                    <FontAwesomeIcon
                      icon={faTrash}
                      size="1x"
                      onClick={() => {
                        setItemId(dataForList?.data[i]?.id);
                        toggleDeleteModal(dataForList?.data[i]?.id);
                      }}
                    />
                  </CustomTooltip>
                </div>
              </>
            ) : (
              <></>
            ),
          bank_transaction_data: dataForList?.data[i],
        });
      }
    }
    return items;
  };
  const listViewData = listViewDataGenerator(dataForList?.data?.length);
  useEffect(() => {
    if (updateResponse) {
      let data = dataForGrid.map((item) =>
        item.id === updateResponse.id ? updateResponse : item
      );
      setDataForGrid(data);
      const matchedRecords = [];
      data?.forEach((element) => {
        element?.bank_reconciliation.forEach((item) => {
          const isValid =
            (item?.receipt_id || item?.payment_detail_id || item?.invoice_id) &&
            item?.description &&
            item?.amount;

          if (isValid) {
            matchedRecords.push(element.id);
          }
        });
      });

      const uniqueMatched = [...new Set(matchedRecords)];

      setSelectedIds((prev = []) => {
        const merged = new Set([...prev, ...uniqueMatched]);
        return Array.from(merged);
      });
      setValidIds((prev = []) => {
        const merged = new Set([...prev, ...uniqueMatched]);
        return Array.from(merged);
      });

      if (view === "list") {
        fetchReconcileTransaction(currentPage - 1);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updateResponse]);

  useEffect(() => {
    navigate(
      `?tab=${
        underReview ? "under-review" : "reconcile-transactions"
      }&view=${view}${
        view === "list"
          ? `&limit=${limit ? limit : defaultLimitPagination}&page=${
              page ? page : 1
            }`
          : ""
      }&from=${
        moment(selectedDateRange?.from).format("DD-MM-YYYY")
          ? moment(selectedDateRange?.from).format("DD-MM-YYYY")
          : ""
      }&to=${
        moment(selectedDateRange?.to).format("DD-MM-YYYY")
          ? moment(selectedDateRange?.to).format("DD-MM-YYYY")
          : ""
      }`,
      { replace: true }
    );
  }, [
    limit,
    navigate,
    page,
    selectedDateRange?.from,
    selectedDateRange?.to,
    underReview,
    view,
  ]);

  const handleRefresh = async () => {
    try {
      setLoading(true);
      await get(
        `${API.REFRESH_BANK_TRANSACTION}?start_date=${
          moment(refreshSelectedDateRange?.from).format("DD-MM-YYYY")
            ? moment(refreshSelectedDateRange?.from).format("DD-MM-YYYY")
            : ""
        }&end_date=${
          moment(refreshSelectedDateRange?.to).format("DD-MM-YYYY")
            ? moment(refreshSelectedDateRange?.to).format("DD-MM-YYYY")
            : ""
        }&trust_id=${trustId}`
      );
      setLoading(false);
      fetchReconcileTransaction(page);
      toggleRefreshModal();
    } catch (e) {
      setLoading(false);
      return null;
    }
  };

  return readAccess ? (
    <div className="relative">
      <MainBody
        search={false}
        innerBody={true}
        actionAlign={"between"}
        loading={loading || loadingForList}
        parentHeight={true}
        actionContent={
          <>
            <div className="flex items-center gap-1">
              <Checkbox
                //   checked={
                //     selectedIds.length = 0 &&
                //     dataForGrid.every((item) => selectedIds.includes(item.id))
                //   }
                checked={
                  validIds?.length !== 0 &&
                  validIds?.length === selectedIds?.length
                }
                onClick={handleSelectAll}
              />
              Select All - {selectedIds?.length}
            </div>

            <div className="flex items-center gap-2">
              <AnimatedTooltip title={"Sync With Yodlee"} bottomAlign>
                <Button
                  onClick={() => toggleRefreshModal()}
                  className="flex gap-2 items-center"
                >
                  Fetch <RefreshCcw size={18} />
                </Button>
              </AnimatedTooltip>
              <CalendarDatePicker
                date={selectedDateRange}
                onDateSelect={(e) => {
                  setDataForGrid([]);
                  setDataForList([]);
                  setSelectedDateRange(e);
                }}
                variant="outline"
                align={isDesktop ? "end" : "start"}
                disabledDate={(date) => date > new Date()}
              />
              <AnimatedTooltip title={"Reconcile"} bottomAlign>
                <Button
                  disabled={selectedIds?.length === 0}
                  onClick={() => toggleReconcileAllModal()}
                >
                  Reconcile Selected
                </Button>
              </AnimatedTooltip>

              <FilterDropDownButton items={items} onReset={handleReset} />

              <div className="relative inline-flex p-1 bg-muted rounded-full border shadow-sm gap-1">
                {["grid", "list"].map((type) => {
                  const Icon = type === "grid" ? LayoutGrid : List;
                  const isActive = view === type;

                  return (
                    <button
                      key={type}
                      onClick={() => {
                        setView(type);
                        setSearchIds([]);
                      }}
                      className={`relative z-10 flex items-center justify-center w-7 h-7 rounded-full transition-colors duration-200 ${
                        isActive ? "text-white" : "text-muted-foreground"
                      }`}
                    >
                      <Icon className="w-4 h-4 relative z-10" />
                      {isActive && (
                        <motion.span
                          layoutId="switch-indicator"
                          className="absolute inset-0 bg-webPrimary border rounded-full shadow"
                          transition={{
                            type: "spring",
                            stiffness: 300,
                            damping: 30,
                          }}
                        />
                      )}
                    </button>
                  );
                })}
              </div>
            </div>
          </>
        }
      >
        <AnimatePresence mode="wait">
          {view === "grid" ? (
            <InfiniteScroll
              dataLength={dataForGrid?.length}
              next={() => fetchReconcileTransaction(currentPage)}
              hasMore={hasMore}
            >
              <motion.div
                key="grid"
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -10 }}
                transition={{ duration: 0.3 }}
                className="grid grid-cols-1 gap-4"
              >
                {dataForGrid.map((item, index) => (
                  <Card
                    className={`${
                      // validIds?.find((validId) => validId === item?.id)
                      !handleReconcileDisable(item)
                        ? "border-green-500 border"
                        : "rounded-md border border-red-500"
                    } `}
                    key={index}
                  >
                    <CardContent className="p-3 relative">
                      <Checkbox
                        checked={selectedIds.includes(item.id)}
                        onClick={() => handleSelectItem(item.id)}
                        className="absolute top-2 left-2 my-1 ml-1"
                        disabled={
                          // underReview === true
                          //   ? false
                          //   :
                          handleReconcileDisable(item)
                        }
                      />
                      <div className="grid xl:grid-cols-8 grid-flow-row-dense ml-6 gap-5">
                        <Card className="rounded-md bg-white dark:bg-transparent xl:col-span-2 col-span-5 h-fit">
                          <CardHeader className="p-0 pb-0 bg-webPrimary rounded-ss-md rounded-se-md text-white">
                            <div className="w-full rounded-md rounded-b-none px-2 py-1.5 text-sm font-bold border-b">
                              <div className="flex items-center justify-between">
                                Bank Transaction
                                {writeAccess ? (
                                  <div className="flex items-center gap-2">
                                    <div
                                      onClick={() => onSearchItem(item?.id)}
                                      className="hover:cursor-pointer dark:hover:bg-white dark:hover:text-muted hover:bg-black hover:text-white dark:text-white text-black bg-muted dark:bg-background rounded-sm h-5 w-5 flex items-center justify-center"
                                    >
                                      <SearchIcon className="h-4 w-4" />
                                    </div>
                                    <DropDownButton
                                      items={
                                        underReview
                                          ? [
                                              {
                                                label: "Search",
                                                onClick: () => {
                                                  onSearchItem(item?.id);
                                                },
                                              },

                                              {
                                                label: "Delete",
                                                onClick: () => {
                                                  setItemId(item?.id);
                                                  toggleDeleteModal(item?.id);
                                                },
                                                danger: true,
                                              },
                                            ]
                                          : [
                                              {
                                                label: "Search",
                                                onClick: () => {
                                                  onSearchItem(item?.id);
                                                },
                                              },
                                              {
                                                label: "Send For Review",
                                                onClick: () => {
                                                  sendReview(item.id, item);
                                                },
                                              },
                                              {
                                                label: "Delete",
                                                onClick: () => {
                                                  setItemId(item?.id);
                                                  toggleDeleteModal(item?.id);
                                                },
                                                danger: true,
                                              },
                                            ]
                                      }
                                      dropdownMenuTriggerBody={
                                        <div className="hover:cursor-pointer dark:hover:bg-white dark:hover:text-muted hover:bg-black hover:text-white dark:text-white text-black bg-muted dark:bg-background rounded-sm h-5 w-4 flex items-center justify-center">
                                          <MoreVertical className="h-4 w-4" />
                                        </div>
                                      }
                                    />
                                  </div>
                                ) : (
                                  <></>
                                )}
                              </div>
                            </div>
                          </CardHeader>
                          <CardContent className="p-3 py-2">
                            <div>
                              <div className="flex items-center gap-2">
                                <Label>Date:</Label>
                                {item?.transaction_date}
                              </div>
                              <div className="flex items-center gap-2">
                                <Label>
                                  {item?.base_type ? "Credit" : "Debit"}:
                                </Label>
                                <span
                                  className={
                                    item?.base_type
                                      ? "text-green-500"
                                      : "text-red-500"
                                  }
                                >
                                  {item?.amount
                                    ? `$${formatNumber(Number(item?.amount))}`
                                    : "$0.00"}
                                </span>
                              </div>
                              <div className="flex items-start gap-2">
                                <Label className="mt-1">Description:</Label>
                                <div>{item?.description}</div>
                              </div>
                              {/* <div className="flex items-start gap-2 mt-1">
                                <Label>Comment:</Label>
                                <div>
                                  <Input
                                    defaultValue={
                                      dataForGrid.comment
                                        ? dataForGrid.comment
                                        : ""
                                    }
                                    placeholder="Add Comment"
                                    onBlur={(e) => {
                                      const newValue = e.target.value;
                                      const id = dataForGrid?.id;

                                      if (
                                        id &&
                                        newValue !== dataForGrid.comment
                                      ) {
                                        updateReviewComment(id, newValue);
                                      }
                                    }}
                                    className="h-8 px-2 bg-background dark:bg-muted"
                                    title={dataForGrid.comment}
                                  />
                                </div>
                              </div> */}
                            </div>
                          </CardContent>
                        </Card>
                        <div className="self-center xl:col-span-1 col-span-5 w-full flex items-center justify-center">
                          <Button
                            // variant={ready ? "default" : "secondary"}
                            title={
                              !writeAccess ? "You don't have the access" : ""
                            }
                            disabled={
                              !writeAccess || handleReconcileDisable(item)
                            }
                            onClick={() => {
                              handleReconcile(item?.id);
                            }}
                          >
                            Reconcile
                          </Button>
                        </div>

                        <Card className="rounded-md bg-white dark:bg-transparent col-span-5 h-fit">
                          <CardHeader className="p-0 pb-0 bg-webPrimary rounded-ss-md rounded-se-md text-white">
                            <div className="w-full rounded-md rounded-b-none px-2 py-1.5 text-sm font-bold border-b">
                              <div className="flex items-center justify-between">
                                Allocation to Accounts
                                {writeAccess ? (
                                  <div className="flex items-center gap-2">
                                    <div
                                      onClick={() => onSearchItem(item?.id)}
                                      className="hover:cursor-pointer dark:hover:bg-white dark:hover:text-muted hover:bg-black hover:text-white dark:text-white text-black bg-muted dark:bg-background rounded-sm h-5 w-5 flex items-center justify-center"
                                    >
                                      <SearchIcon className="h-4 w-4" />
                                    </div>
                                    <DropDownButton
                                      items={
                                        underReview
                                          ? [
                                              {
                                                label: "Search",
                                                onClick: () => {
                                                  onSearchItem(item?.id);
                                                },
                                              },
                                            ]
                                          : [
                                              {
                                                label: "Search",
                                                onClick: () => {
                                                  onSearchItem(item?.id);
                                                },
                                              },
                                              {
                                                label: "Send For Review",
                                                onClick: () => {
                                                  sendReview(item.id, item);
                                                },
                                              },
                                            ]
                                      }
                                      dropdownMenuTriggerBody={
                                        <div className="hover:cursor-pointer dark:hover:bg-white dark:hover:text-muted hover:bg-black hover:text-white dark:text-white text-black bg-muted dark:bg-background rounded-sm h-5 w-4 flex items-center justify-center">
                                          <MoreVertical className="h-4 w-4" />
                                        </div>
                                      }
                                    />
                                  </div>
                                ) : (
                                  <></>
                                )}
                              </div>
                            </div>
                          </CardHeader>
                          <CardContent className="relative p-2">
                            {/* {item?.bank_reconciliation?.length > 0 && (
                              <div className="grid md:grid-cols-2 mb-2">
                                <div>
                                  <div className="flex items-start gap-2">
                                    <Label className="mt-1">Contact:</Label>
                                    <div>
                                      {item?.bank_reconciliation[0]?.contact
                                        ? formatSubcontractorName(
                                            item?.bank_reconciliation[0]
                                              ?.contact
                                          )
                                        : "-"}
                                    </div>
                                  </div>
                                  <div className="flex items-start gap-2">
                                    <Label className="mt-1">Vendor:</Label>
                                    <div>
                                      {item?.bank_reconciliation[0]?.vendor
                                        ? formatSubcontractorName(
                                            item?.bank_reconciliation[0]?.vendor
                                          )
                                        : "-"}
                                    </div>
                                  </div>
                                </div>
                                <div>
                                  <div className="flex items-start gap-2">
                                    <Label className="mt-1">Asset:</Label>
                                    <div>
                                      {item?.bank_reconciliation[0]?.asset
                                        ? item?.bank_reconciliation[0]?.asset
                                            ?.name
                                        : "-"}
                                    </div>
                                  </div>
                                  <div className="flex items-start gap-2">
                                    <Label className="mt-1">Sub Asset:</Label>
                                    <div>
                                      {item?.bank_reconciliation[0]?.sub_asset
                                        ? item?.bank_reconciliation[0]
                                            ?.sub_asset?.name
                                        : "-"}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )} */}
                            <div className="table-body-class">
                              <BootstrapTable
                                keyField="key"
                                remote
                                data={bankReconciliationData(
                                  item?.bank_reconciliation
                                )}
                                columns={columns}
                                rowClasses={`${TRClasses} hover:!bg-background`}
                                noDataIndication="No Data Found"
                                classes={TableClasses}
                                wrapperClasses={TableWrapClasses}
                              />
                            </div>
                          </CardContent>
                        </Card>
                      </div>

                      {searchIds?.find((searchId) => searchId === item?.id) && (
                        <SearchItem
                          item={item}
                          removeSearchId={removeSearchId}
                          searchParams={Number(item?.amount)}
                          trustId={trustId}
                          setUpdatedResponse={setUpdatedResponse}
                        />
                      )}
                    </CardContent>
                  </Card>
                ))}
              </motion.div>
            </InfiniteScroll>
          ) : (
            <motion.div
              key="list"
              initial={{ opacity: 0, x: 10 }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: -10 }}
              transition={{ duration: 0.3 }}
              className="space-y-4 overflow-x-auto"
            >
              <div className="table-body-class sm:max-h-[619px]">
                <BootstrapTable
                  keyField="key"
                  columns={listColumns}
                  data={listViewData}
                  rowClasses={TRClasses}
                  noDataIndication="No Data Found"
                  classes={TableClasses}
                  wrapperClasses={TableWrapClasses}
                />
              </div>
              <Pagination
                total={total}
                limit={parseInt(limit)}
                currentPage={page}
                updateLimit={handleUpdateLimit}
                updatePage={handleChangePage}
                from={from}
                to={to}
              />
              {searchIds?.find((searchId) => searchId === itemData?.id) && (
                <ResponsiveDrawerForm
                  description={""}
                  title={"Search"}
                  handleOpen={() => {}}
                  handleClose={() => {}}
                  className={"sm:max-w-full"}
                  open={showSearch}
                  buttonClassName={""}
                  setOpen={setShowSearch}
                  mobileCancelHidden={true}
                  write={true}
                  popupType={"bank-reconciliations"}
                >
                  <SearchItem
                    item={itemData}
                    removeSearchId={removeSearchId}
                    searchParams={Number(itemData?.amount)}
                    trustId={trustId}
                    setUpdatedResponse={setUpdatedResponse}
                  />
                </ResponsiveDrawerForm>
              )}
            </motion.div>
          )}
        </AnimatePresence>
      </MainBody>
      <Confirmation
        title={"Delete Reconcile Transaction"}
        open={showDelete}
        setOpen={setShowDelete}
        // toggleShow={() => {
        //   toggleDeleteModal();
        // }}
        handleClose={() => {
          setItemId();
        }}
        popupType={"bank-reconciliations"}
        className="sm:max-w-fit"
        message={`Are your sure you want to delete this reconcile transaction?`}
        okAction={async () => {
          await handleReconcileTransactionDelete(dataForGrid, itemId);
        }}
        loading={deleteLoading}
        cancelAction={() => {
          toggleDeleteModal();
        }}
      />

      <Confirmation
        title={"Bullk Reconcile Transaction"}
        open={showReconcileAll}
        setOpen={setShowReconcileAll}
        // toggleShow={() => {
        //   toggleDeleteModal();
        // }}
        handleClose={() => {
          setItemId();
        }}
        popupType={"bank-reconciliations"}
        className="sm:max-w-fit"
        message={` Are your sure you want to reconcile this bank transaction?`}
        okAction={async () => {
          await bulkReconcile();
        }}
        loading={loading}
        cancelAction={() => {
          toggleReconcileAllModal();
        }}
      />

      <Confirmation
        title={"Fetch Bank Transaction"}
        open={showRefreshModal}
        setOpen={setShowRefreshModal}
        toggleShow={() => {
          toggleRefreshModal();
        }}
        popupType={"yodlee"}
        className="sm:max-w-[400px]"
        message={
          <>
            <div className="grid gap-2">
              <Label htmlFor="transaction_ate">
                <CustomLabelText required={true} labelText="Transaction Date" />
              </Label>
              <CalendarDatePicker
                date={refreshSelectedDateRange}
                onDateSelect={setRefreshSelectedDateRange}
                variant="outline"
                align={isDesktop ? "end" : "start"}
              />
            </div>
          </>
        }
        okAction={async () => {
          await handleRefresh();
        }}
        loading={loading}
        cancelAction={() => {
          toggleRefreshModal();
        }}
      />
    </div>
  ) : (
    <UnauthorisedAccess expandList={true} popup={true} />
  );
};

export default ReconcileTransactions;
